import React, { useState } from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import { AgentBuilderPage } from './pages/AgentBuilder';
import { AgentRegistryPage } from './pages/AgentRegistry';
import { WorkflowBuilderPage } from './pages/WorkflowBuilder';
import { IntegrationsHubPage } from './pages/IntegrationsHub';
import { MarketingPage } from './pages/MarketingPage';
import { ProductDetailPage } from './pages/ProductDetailPage';
import { PricingOverviewPage } from './pages/PricingOverviewPage';

type AppPage = 'home' | 'agents' | 'registry' | 'workflows' | 'integrations';

function AppShell() {
  const [page, setPage] = useState<AppPage>('home');

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Top Navigation */}
      <nav className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex gap-6 py-4 items-center">
            <Link to="/" className="flex items-center gap-2 mr-4">
              <div className="w-7 h-7 bg-blue-600 rounded-md flex items-center justify-center">
                <span className="text-white font-bold text-xs">智</span>
              </div>
              <span className="text-gray-900 font-bold text-sm">智纬AI</span>
            </Link>
            <div className="flex gap-1 flex-1">
              {([
                ['home', '首页'],
                ['agents', 'Agent Builder'],
                ['registry', 'Registry'],
                ['workflows', 'Workflows'],
                ['integrations', 'Integrations'],
              ] as const).map(([key, label]) => (
                <button
                  key={key}
                  onClick={() => setPage(key)}
                  className={`px-3 py-1.5 rounded-md text-sm font-medium transition ${
                    page === key
                      ? 'bg-blue-50 text-blue-600'
                      : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                  }`}
                >
                  {label}
                </button>
              ))}
            </div>
          </div>
        </div>
      </nav>

      {page === 'home' && (
        <div className="max-w-7xl mx-auto py-12 px-4 text-center">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Company AI Platform</h1>
          <p className="text-xl text-gray-600 mb-8">Build, deploy, and manage AI agents and workflows without writing code.</p>
          <div className="flex gap-4 justify-center flex-wrap">
            <button onClick={() => setPage('agents')} className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700">
              Start Building Agents
            </button>
            <button onClick={() => setPage('workflows')} className="px-6 py-3 bg-purple-600 text-white rounded-lg hover:bg-purple-700">
              Create Workflow
            </button>
            <button onClick={() => setPage('integrations')} className="px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700">
              Connect Integrations
            </button>
            <button onClick={() => setPage('registry')} className="px-6 py-3 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50">
              Browse Registry
            </button>
          </div>
        </div>
      )}

      {page === 'agents' && <AgentBuilderPage />}
      {page === 'registry' && <AgentRegistryPage />}
      {page === 'workflows' && <WorkflowBuilderPage />}
      {page === 'integrations' && <IntegrationsHubPage />}
    </div>
  );
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<MarketingPage />} />
      <Route path="/pricing" element={<PricingOverviewPage />} />
      <Route path="/product/:productId" element={<ProductDetailPage />} />
      <Route path="/app/*" element={<AppShell />} />
    </Routes>
  );
}

export default App;
